import { sBanner, sBannerStep } from '../../shared.min.js';

let jsonData = null;

const dashCamTool = (function () {
	const cmsText = document.getElementById('dct-cms'),
		widget = document.getElementById('cnfsd-dct-widget'),
		form = document.getElementById('cnfsd-dct-form'),
		formContinueButton = document.getElementById('dct-details-continue'),
		resultSection = document.getElementById('cnfsd-dct-results'),
		resultTitle = document.getElementById('cnfsd-dct-results-title-police-constabulary'),
		resultContent = document.getElementById('dct-results-content'),
		countryFieldset = document.getElementById('dct-country'),
		countryDropdown = document.getElementById('dct-country-select'),
		englandCountySelect = document.getElementById('dct-england-county'),
		walesCountySelect = document.getElementById('dct-wales-county'),
		englandCountySelectField = document.getElementById('dct-england-county-select'),
		walesCountySelectField = document.getElementById('dct-wales-county-select'),
		reportsMade = document.getElementById('reports-made-percentage'),
		finesIssued = document.getElementById('fines-issues-percentage'),
		bannerStep1Text = cmsText.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = cmsText.getAttribute('data-banner-step-2-text'),
		restartButton = document.getElementById('dct-results-restart'),
		submitReportButton = document.getElementById('dct-results-report'),
		dataUrl = cmsText.getAttribute('data-json');

	let selectedCountry = null,
		selectedCounty = null;

	async function init() {
		if (!widget) return;
		if (dataUrl || !dataUrl.trim() === '') {
			const data = await fetch(dataUrl);
			jsonData = await data.json();
		} else {
			jsonData = widget.getAttribute('data-json');
			jsonData = jsonData ? JSON.parse(jsonData) : null;
		}

		const englandCounties = jsonData.England,
			walesCounties = jsonData.Wales;

		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);

		function restartCalc() {
			form.classList.remove('display-none');
			resultSection.classList.add('display-none');
			document.getElementById('dct-wales-county').classList.add('display-none');
			document.getElementById('dct-england-county').classList.add('display-none');
			const firstOption = countryDropdown.options[0];
			firstOption.disabled = false;
			countryDropdown.selectedIndex = 0;
			firstOption.disabled = true;
			sBannerStep(1);
		}

		function displayCountryError() {
			if (countryFieldset) {
				countryFieldset.classList.add('field-group--error');
			}
		}

		function displayCountyError(country) {
			if (country === 'england') {
				if (englandCountySelect) {
					englandCountySelect.classList.add('field-group--error');
				}
			} else if (country === 'wales') {
				if (walesCountySelect) {
					walesCountySelect.classList.add('field-group--error');
				}
			}
		}

		function formatCountryName(country) {
			if (!country) return '';
			const lower = country.toLowerCase();
			if (lower === 'ni') return 'Northern Ireland';
			if (lower === 'scotland') return 'Scotland';
			if (lower === 'wales') return 'Wales';
			if (lower === 'england') return 'England';
			// Capitalize first letter, lowercase the rest
			return country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
		}

		function displayCountryDropdown(countryCode) {
			if (countryCode === 'england') {
				document.getElementById('dct-england-county').classList.remove('display-none');
				document.getElementById('dct-wales-county').classList.add('display-none');
			} else if (countryCode === 'wales') {
				document.getElementById('dct-wales-county').classList.remove('display-none');
				document.getElementById('dct-england-county').classList.add('display-none');
			} else {
				document.getElementById('dct-england-county').classList.add('display-none');
				document.getElementById('dct-wales-county').classList.add('display-none');
			}
		}

		function handleReportButtonClick(link) {
			if (!link) return;
			window.open(link, '_blank');
		}

		function showResult(country, county = '') {

			const formattedCountry = formatCountryName(country);
			const countryData = jsonData[formattedCountry];
			let countyData;
			sBannerStep(2);
			form.classList.add('display-none');
			resultSection.classList.remove('display-none');
			if (formattedCountry === 'Northern Ireland' || formattedCountry === 'Scotland') {
				resultTitle.textContent = countryData._countrywide.force;
				if (countryData._countrywide.link == null || countryData._countrywide.link === '') {
					submitReportButton.classList.add('display-none');
				} else {
					submitReportButton.classList.remove('display-none');
					submitReportButton.addEventListener('click', function (e) {
						e.preventDefault();
						handleReportButtonClick(countryData._countrywide.link);
					});
				}
				if (
					countryData._countrywide.fines == null ||
					countryData._countrywide.fines === 0 ||
					countryData._countrywide.reportsMade == null ||
					countryData._countrywide.reportsMade === 0
				) {
					resultContent.classList.add('display-none');
				} else {
					reportsMade.textContent = countryData._countrywide.reportsMade;
					finesIssued.textContent = countryData._countrywide.fines;
					resultContent.classList.remove('display-none');
				}
			} else {
				countyData = countryData[county];
				resultTitle.textContent = countyData.force;
				if (countyData.link == null || countyData.link === '') {
					submitReportButton.classList.add('display-none');
				} else {
					submitReportButton.classList.remove('display-none');
					submitReportButton.addEventListener('click', function (e) {
						e.preventDefault();
						handleReportButtonClick(countyData.link);
					});
				}
				if (
					countyData.fines == null ||
					countyData.fines === 0 ||
					countyData.reportsMade == null ||
					countyData.reportsMade === 0
				) {
					resultContent.classList.add('display-none');
				} else {
					reportsMade.textContent = countyData.reportsMade;
					finesIssued.textContent = countyData.fines;
					resultContent.classList.remove('display-none');
				}
			}
		}

		function populateCountyDropdown(countries, selectId) {
			if (!Array.isArray(countries) && typeof countries === 'object' && countries !== null) {
				countries = Object.keys(countries).map(key => ({
					name: key,
					...countries[key],
				}));
			}
			const select = document.getElementById(selectId);
			if (!select) return;
			// Remove any existing options except the first (placeholder)
			select.innerHTML = `<option disabled value="" selected>Select a county</option>`;
			countries.forEach(country => {
				const option = document.createElement('option');
				option.value = country.name;
				option.textContent = country.name;
				select.appendChild(option);
			});
		}

		if (countryDropdown) {
			countryDropdown.addEventListener('change', function () {
				countryFieldset && countryFieldset.classList.remove('field-group--error');
				const selectedRegion = this.value;
				displayCountryDropdown(selectedRegion);

				// Reset county selects to first option (even if disabled)
				if (englandCountySelect) {
					const firstOption = englandCountySelectField.options[0];
					firstOption.disabled = false;
					englandCountySelectField.selectedIndex = 0;
					firstOption.disabled = true;
				}
				if (walesCountySelect) {
					const firstOption = walesCountySelectField.options[0];
					firstOption.disabled = false;
					walesCountySelectField.selectedIndex = 0;
					firstOption.disabled = true;
				}
			});
		}

		if (englandCountySelect || walesCountySelect) {
			englandCountySelect &&
				englandCountySelect.addEventListener('change', function () {
					englandCountySelect.classList.remove('field-group--error');
					walesCountySelect.classList.remove('field-group--error');
				});
			walesCountySelect &&
				walesCountySelect.addEventListener('change', function () {
					englandCountySelect.classList.remove('field-group--error');
					walesCountySelect.classList.remove('field-group--error');
				});
		}

		populateCountyDropdown(englandCounties, 'dct-england-county-select');
		populateCountyDropdown(walesCounties, 'dct-wales-county-select');

		formContinueButton.addEventListener('click', function (e) {
			e.preventDefault();
			countryFieldset && countryFieldset.classList.remove('field-group--error');
			englandCountySelect.classList.remove('field-group--error');
			walesCountySelect.classList.remove('field-group--error');
			selectedCountry = countryDropdown ? countryDropdown.value : null;

			if (!selectedCountry) {
				displayCountryError('none');
				return;
			}
			if (countryDropdown.value === 'england') {
				const countySelect = document.getElementById('dct-england-county-select');
				selectedCounty = countySelect ? countySelect.value : null;
				if (!selectedCounty) {
					displayCountyError(countryDropdown.value);
					return;
				}
				showResult(selectedCountry, selectedCounty);
			} else if (countryDropdown.value === 'wales') {
				const countySelect = document.getElementById('dct-wales-county-select');
				selectedCounty = countySelect ? countySelect.value : null;
				if (!selectedCounty) {
					displayCountyError(countryDropdown.value);
					return;
				}
				showResult(selectedCountry, selectedCounty);
			} else {
				selectedCounty = null;
				showResult(selectedCountry);
			}
		});

		restartButton.addEventListener('click', e => {
			e.preventDefault();
			restartCalc();
		});
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	dashCamTool.init();
});
